/**
 * @fileoverview DELETE handler for the "/integrations/direct/cdi/segments_config/:segments_config_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiSegmentsConfigSegmentsConfigIdCacheKeys } from "./constants";
import type { DeleteIntegrationsDirectCdiSegmentsConfigSegmentsConfigIdProps } from "./types";

export const deleteCdiSegmentsConfig = reactQueryMutationAdapter(
  integrationsDirectCdiSegmentsConfigSegmentsConfigIdCacheKeys,
  (props: DeleteIntegrationsDirectCdiSegmentsConfigSegmentsConfigIdProps): Promise<null> => {
    return fetch(
      `/integrations/direct/cdi/segments_config/${props.segmentsConfigId}`,
      "DELETE",
      { partner_name: props.partnerName },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
